import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  contribuinteLogado: null,
  dadosCadastrais: {},
  dadosCadastraisDetalhar: null,
};

export const duckDadosContribuinteLogado = createAction('DUCK_DADOS_CONTRIBUINTE_LOGADO');
export const duckDadosCadastraisDetalhar = createAction('DUCK_DADOS_CADASTRAIS_DETALHAR');
export const duckDadosCadastrais = createAction('DUCK_DADOS_CADASTRAIS');

export default createReducer(INITIAL_STATE, {
  [duckDadosContribuinteLogado.type]: (state, action) => ({
    ...state,
    contribuinteLogado: action.payload,
  }),
  [duckDadosCadastraisDetalhar.type]: (state, action) => ({
    ...state,
    dadosCadastraisDetalhar: action.payload,
  }),
  [duckDadosCadastrais.type]: (state, action) => ({
    ...state,
    dadosCadastrais: action.payload,
  }),
});
